module.exports = __webpack_public_path__ + "assets/0.1.11/img/404_cloud.0f4bc32b.png";